// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  itemId: __t.u64().primaryKey().name("item_id"),
  structureId: __t.u64().name("structure_id"),
  prefabId: __t.string().name("prefab_id"),
  modelAssetId: __t.u64().name("model_asset_id"),
  lx: __t.f32(),
  ly: __t.f32(),
  lz: __t.f32(),
  pitch: __t.f32(),
  yaw: __t.f32(),
  roll: __t.f32(),
  placedBy: __t.identity().name("placed_by"),
  placedAt: __t.timestamp().name("placed_at"),
  itemKey: __t.string().name("item_key"),
  packedItemJson: __t.string().name("packed_item_json"),
});
